





























































































import IconButton from '@/components/Common/IconBtn.vue';
import TableComp from '@/components/Common/TableComp.vue';
import SearchGroup from '@/components/Common/SearchGroup.vue';
import TableOperaBtn from '@/components/Common/TableOperaBtn.vue';
import SubordinateListDialog from './SubordinateListDialog.vue';
import SetBusinessSuperiorDialog from './SetBusinessSuperiorDialog.vue';
import { Component, Prop, Vue } from 'vue-property-decorator';
import {
  setBmsPermissionApi,
  getDefaultRoleListApi,
  setSubagentPermissionApi,
  getPermissionGearUserListApi,
} from '@/api/company';
import { debounce } from '@/utils/function_utils';

interface IReqFilter {
  keyword: string;
  typeKey: string;
}

@Component({
  name: 'businessAccountList',
  components: {
    TableComp,
    IconButton,
    SearchGroup,
    TableOperaBtn,
    SubordinateListDialog,
    SetBusinessSuperiorDialog,
  }
})
export default class extends Vue {
  @Prop({ default: true }) public hasAgent!: boolean;

  public tableData: any = [];
  public typeKeyOptions: any = [];
  public dialogVisible: boolean = false;
  public dialogVisibleSetSuperior: boolean = false;
  public currentRow: any = {};
  public reqFilter: IReqFilter = {
    keyword: '',
    typeKey: '',
  }

  // 利用防抖避免连续多次点击发送多次请求
  public getTables = debounce(this.getTableDatas, 500);

  public created() {
    // this.getTables();
    this.getTypeKeyOptions();
  }

  public async getTypeKeyOptions() {
    const { data } = await getDefaultRoleListApi();
    this.typeKeyOptions = data.datas;
  }

  public async getTableDatas() {
    const { data } = await getPermissionGearUserListApi(this.reqFilter);
    this.tableData = data.datas;
  }

  public handleAdd() {
    this.$router.push({ name: 'contactPerson', params: { id: 'add' } });
  }

  public handleEdit(row: any) {
    const id = row.id;
    this.$router.push({ name: 'contactPerson', params: { id } });
  }

  public handleSearch() {
    this.getTables();
  }

  public handleReset() {
    this.reqFilter = {
      keyword: '',
      typeKey: '',
    }
    this.getTables();
  }

  public handleRefresh() {
    this.getTables();
  }

  public async handleChangeSwitch(row: any) {
    const fkUserId = row.id;
    const isSubagentPermission = row.isSubagentPermission;
    try {
      await setSubagentPermissionApi({ fkUserId, isSubagentPermission });
      this.$message.success(this.$t('message.setSuccess') as string);
      this.getTables();
    } catch(err) {
      //
    }
  }

  public async handleChangeSwitchBMSDataOpen(row: any) {
    const fkUserId = row.id;
    const isBmsPermission = row.isBmsPermission;
    try {
      await setBmsPermissionApi({ fkUserId, isBmsPermission });
      this.$message.success(this.$t('message.setSuccess') as string);
      this.getTables();
    } catch(err) {
      //
    }
  }

  public handleSetSuperior(row: any) {
    this.currentRow = row;
    this.dialogVisibleSetSuperior = true;
  }

  public handleViewSubordinate(row: any) {
    this.currentRow = row;
    this.dialogVisible = true;
  }
}
